import { type InputHTMLAttributes } from 'react'

import { extractInputProps, type InputProps } from '@/defs/input'
import { type DistributiveOmit } from '@/defs/misc'
import { cn } from '@/utils/commonUtil'

import styles from './InputTextarea.module.scss'

type BaseProps = {
  onChange?: (value: string) => void
}

type Props = BaseProps &
  InputProps &
  DistributiveOmit<InputHTMLAttributes<HTMLTextAreaElement>, keyof BaseProps | keyof InputProps | 'className'>

export const InputTextarea = ({ onChange, value, ...props }: Props) => {
  const isEmpty = !value
  const { inputProps, rest } = extractInputProps(props)

  return (
    <div className={cn(styles.container, { styles, ...inputProps })}>
      <div className={styles.field}>
        <textarea
          className={cn(styles.input, { isEmpty, styles })}
          onChange={(e) => onChange && onChange(e.currentTarget.value)}
          value={value || ''}
          {...rest}
        />
      </div>
    </div>
  )
}
